import React, { useState, useMemo, useRef, useEffect } from 'react';
import useRepo from '../../hooks/useRepo';
import useApiContext from 'hooks/useApiContext';
import { useLocation, useParams } from 'react-router-dom';
import { T, M, A } from 'TOMA';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputText } from '../../form';
import s from '../Event/Event.module.scss';
import { useTranslation } from 'react-i18next';
function AddCompany(): JSX.Element {
  const { userRepository } = useApiContext();
  const { userId } = useParams();
  const { pathname } = useLocation();
  const [loadingForm, setLoadingForm] = useState(false);
  const [successForm, setSuccessForm] = useState(false);
  const user = userRepository.getUser();
  const [errorForm, setErrorForm] = useState<string>();
  const { t } = useTranslation();
  const { response, loading } = useRepo(async () => {
    return await userRepository
      .getUserById(userId ?? 'new_user')
      .then((e) => e);
  }, [pathname]);

  const schema = yup.object({
    count_of_moderators: yup.number().nullable(),
    count_of_exhibitors: yup.number().nullable(),
    firstname: yup
      .string()
      .max(255)
      .required('This field is required')
      .nullable(),
    lastname: yup
      .string()
      .max(255)
      .required('This field is required')
      .nullable(),
    email: yup.string().max(255).required('This field is required').nullable(),
  });
  const form = useForm<any>({
    mode: 'onChange',
    reValidateMode: 'onBlur',
    resolver: yupResolver(schema),
  });
  const [moderators, setModerators] = useState<any>([]);
  const [exhibitors, setExhibitors] = useState<any>([]);
  const { handleSubmit, watch, control, reset, setValue, getValues } = form;
  useEffect(() => {
    if (userId && !loading && response) {
      reset(response.user);
    }
    if (!loading && response) {
      setExhibitors([...response.exhibitors]);
      setModerators([...response.moderators]);
      setValue('role', 'ADMIN');
    }
  }, [loading, response, form.reset]);
  const options = (): any => {
    const available_options = [];
    available_options.push({ value: 'ADMIN', label: 'Admin' });
    return available_options;
  };
  function onSubmit(data: any): void {
    userRepository
      .createUserFeature(data)
      .then(() => {
        setSuccessForm(true);
        setErrorForm('');
      })
      .catch((err: Error) => {
        setErrorForm(err.message);
      })
      .finally(() => {
        setLoadingForm(false);
      });
  }
  return (
    <M.Loading loading={false} error={null} fullWiewport>
      <T.Block p="20">
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Controller
            name="role"
            control={control}
            render={({ field }) => (
              <A.InputSelect
                {...field}
                label={t('users:role')}
                options={options()}
                value="ADMIN"
                disabled={true}
              />
            )}
          />
          <InputText
            label={t('users:email')}
            name="email"
            type="text"
            control={control}
            disabled={true}
            required
          />
          <InputText
            label={t('users:firstname')}
            name="firstname"
            type="text"
            control={control}
            disabled={true}
            required
          />
          <InputText
            label={t('users:lastname')}
            name="lastname"
            type="text"
            control={control}
            disabled={true}
            required
          />
          <InputText
            label={t('users:phone')}
            name="phone"
            type="tel"
            control={control}
            disabled={true}
            required
          />
          <Controller
            name="moderators"
            control={control}
            render={({ field }) => (
              <A.InputAutocomplete
                {...field}
                label="Moderators"
                name="moderators"
                options={moderators}
                multiple={true}
              />
            )}
          />
          <Controller
            name="exhibitors"
            control={control}
            render={({ field }) => (
              <A.InputAutocomplete
                {...field}
                label={t('users:exhibitors')}
                name="exhibitors"
                options={exhibitors}
                multiple={true}
              />
            )}
          />
          <InputText
            label="Count of moderators"
            name="count_of_moderators"
            type="number"
            control={control}
            disabled={false}
          />
          <InputText
            label={t('users:number_of_authorized_exhibitors')}
            name="count_of_exhibitors"
            type="number"
            control={control}
            disabled={false}
          />
          <InputText
            label="Url"
            name="admin_url"
            type="text"
            control={control}
            disabled={false}
          />
          <div>
            <InputText
              label={t('users:password')}
              name="password"
              type="password"
              control={control}
              disabled={false}
              required
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <A.Button
              type="button"
              bg="success"
              loading={loadingForm}
              onClick={async () => {
                await handleSubmit(() => onSubmit(getValues()))();
              }}
              className={s.submit_button}
              disabled={false}
            >
              {t('home:formInformation.save')}
            </A.Button>
          </div>
          <T.Block mt="20">
            <A.Alert alert="success" side="🎉" mb="15">
              {successForm && 'Successfully!'}
            </A.Alert>
            <A.Alert alert="error" side="⚠️" mb="15">
              {errorForm && <A.InnerHTML html={errorForm} />}
            </A.Alert>
          </T.Block>
        </form>
      </T.Block>
    </M.Loading>
  );
}

export default AddCompany;
